import React from 'react'
import SearchableTableACDCNotCollapsed from '../SearchableTableACDCNotCollapsed'
import CardCurrencyBrandLegend from '../CardCurrencyBrandLegend'
import CardCurrencySpecialCurrencies from '../CardCurrencySpecialCurrencies'

const TableBrandedLimitedRelease = () => {
  return (
    <>
      <SearchableTableACDCNotCollapsed
        rowDataName="card_supported_currencies_branded_lr_focus_row"
        colDataName="card_supported_currencies_branded_lr_focus_column"
        searchKeys={['currencyCode.value', 'currencyName.value']}
        searchable={true}
      />
      <CardCurrencyBrandLegend />
    </>
  )
}

export default TableBrandedLimitedRelease
